import React, { useEffect } from 'react'
import { Alert, Result, Tabs, Typography } from 'antd'

import { useExpertProfilesContext } from '../../../../../context/expertProfile'
import { TExpertPage, TExpertProfile } from '../../../../../context/types'
import SpinLoader from '../../../../helpers/SpinLoader'
import ExpertProfileForm from './ExpertProfileForm'
import './index.less'

const { TabPane } = Tabs
const { Text, Title } = Typography

export default function Expert({ pageChannelName }: { pageChannelName: string }) {
	const { expertProfiles, actions } = useExpertProfilesContext()
	const page = expertProfiles.profiles[0]?.pages.find(
		({ channel }: TExpertPage) => channel.name.toLowerCase() === pageChannelName.toLowerCase()
	)

	useEffect(() => {
		actions.setError()
	}, [])

	const isShowNotification = !expertProfiles.loading && (!page?.title || !page?.body || !page?.keywords?.length)

	if (!expertProfiles.loading && !page) {
		return <Result status="404" title="404" subTitle="We’re sorry, this expert page is unavailable." />
	}

	return (
		<>
			{isShowNotification && (
				<Alert
					type="warning"
					className="fill-data_alert"
					showIcon
					message="Please provide information for all list of expert details:  headline, body, keywords "
					style={{ width: '100%' }}
				/>
			)}

			<div className="expert-title-container">
				<Title level={3}>Profile Page</Title>
			</div>

			<SpinLoader loading={!!expertProfiles.loading}>
				{expertProfiles.profiles.length > 1 ? (
					<Tabs type="card">
						{expertProfiles.profiles?.map((profile: TExpertProfile) => (
							<TabPane tab={profile.brand.name} key={profile.id}>
								<ExpertProfileForm profile={profile} expertPage={page} />
								<Text type="danger">{expertProfiles.error}</Text>
							</TabPane>
						))}
					</Tabs>
				) : (
					<div>
						<ExpertProfileForm profile={expertProfiles.profiles[0]} expertPage={page} />
						<Text type="danger">{expertProfiles.error}</Text>
					</div>
				)}
			</SpinLoader>
		</>
	)
}
